import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';
import Box from '@mui/material/Box';

const ChanceList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowClick,
  columnVisibilityModel,
}) => {
  const [pageSize, setPageSize] = React.useState(20);

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 320px)',  maxWidth: 'calc(80vw - 40px)',  minWidth: '100%' }}>
      <div style={{ flexGrow: 1, minWidth: '100%'  }}>
        <DataGrid
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '포캐스팅_리스트' },
          }}
          density="compact"
          loading={loading}
          onRowClick={handleRowClick}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default ChanceList;
